// extracted by mini-css-extract-plugin
export default {"group_one":"GroupOne_group_one__U+t-D","input_segment":"GroupOne_input_segment__wJuGp"};